import LoginComponent from '../../components/Login'
import '../../styles/LoginForm.scss'
import '../../styles/accountForm.scss'

export default LoginComponent
